import { CandleTriggerSetupModule } from '../../../../components/displays/alerts/components/addAlertComponent/addAlertForm/formComponents/setup/setupDetails/setupDetailsModules/candleTrigger/CandleTriggerSetupModule';
import { CandleTriggerDetailsComponent } from '../../../../components/displays/alerts/components/alertWatchlistComponent/setupDetailsComponents/candleTrigger/CandleTriggerDetailsComponent';
import { parseCandleTriggerNotificationDetails } from '../../../../components/displays/alerts/components/notificationComponent/notificationListItem/notificationSetupParsers/parseCandleTriggerNotificationDetails';
import { CandleTriggerLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/CandleTriggerLine';
import { CandleTriggerTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/setups/CandleTriggerTacticPanel';
import { CandleTriggerWrapper } from '../../../../components/displays/tradeplans/softOrderModules/setupModules/CandleTriggerModule/wrapper/CandleTriggerWrapper';
import CandleTriggerDoc from '../../../../components/forms/tradeplans/documentation/CandleTriggerDocumentation';
import { candleTriggerDetailParser } from '../../../../stores/websocketStore/utils/mungingUtils/alertSoftOrderProcessing/individualSetupDetailParsers/candleTrigger/candleTriggerDetailParser';
import { determineCandleTriggerCandleDuration } from '../../../../stores/websocketStore/utils/mungingUtils/alertSoftOrderProcessing/individualSetupDetailParsers/candleTrigger/determineCandleTriggerCandleDuration';
import { determineCandleTriggerTimeUnit } from '../../../../stores/websocketStore/utils/mungingUtils/alertSoftOrderProcessing/individualSetupDetailParsers/candleTrigger/determineCandleTriggerTimeUnit';
import { CandleTriggerData } from './candleTriggerData';
import { validateCandleTrigger } from './validateCandleTrigger';

export const CandleTrigger = {
  //data class
  dataStore: CandleTriggerData,

  //string constants
  name: 'CANDLE_TRIGGER',
  tacticLabel: 'Candle Trigger',
  addTacticLabel: 'Add Candle Trigger',
  category: 'Setup',

  //components
  tradePlanFormModule: null,
  tacticPanel: CandleTriggerTacticPanel,
  addTacticPanel: null,
  wrapper: CandleTriggerWrapper,
  chartSoftOrderComponent: CandleTriggerLine,
  documentation: CandleTriggerDoc,
  alertDetailsComponent: CandleTriggerSetupModule, 
  alertTableSetupComponent: CandleTriggerDetailsComponent,

  //functions
  setupDetailParser: candleTriggerDetailParser,
  setupNotificationParser: parseCandleTriggerNotificationDetails,
  determineTimeUnit: determineCandleTriggerTimeUnit,
  determineCandleDuration: determineCandleTriggerCandleDuration,
  validateFunction: validateCandleTrigger,
};
